import React, { useEffect, useRef, useState } from "react";
import { FaBell, FaQuestionCircle, FaUser } from "react-icons/fa";
import { FaRegMessage } from "react-icons/fa6";
import {
  DropdownItem,
  DropdownMenu,
  NotificationBadge,
  TopBarContainer,
  TopBarIcon,
  TopBarLeft,
  TopBarName,
  TopBarRight,
  TopBarValidity,
} from "../StyledComp";
import { useHistory } from "react-router-dom";
import { InboxGeneral } from "../../../../../../libraries/src/services/elements/InboxService";
import { ArrowBackIos, ArrowForwardIos, Fullscreen } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

const TopBar = ({ userDetails, applicationDetail, toggleSidebar, collapsed }) => {
  const { info } = userDetails || {};
  const stateId = Digit.ULBService.getStateId();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [count, setCount] = useState(0);
  const dropdownRef = useRef(null);
  const history = useHistory();
  const ownerName = Digit.SessionStorage.get("OWNER_INFO");
  const { t } = useTranslation();
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleEditProfile = () => {
    history.push("/digit-ui/citizen/user/account"); // Replace with your edit profile route
    setIsDropdownOpen(false);
  };
  const handleDashboard = () => {
    history.push("/digit-ui/citizen/profile"); // Replace with your edit profile route
    setIsDropdownOpen(false);
  };
  const filters = {
    tenantId: stateId,
    processSearchCriteria: {
      moduleName: "bpa-services",
      businessService: ["BPA_LANDUSE_DA", "BPA_FAR_DA", "BPA_MAPSUB_DA"],
    },
    moduleSearchCriteria: {
      sortBy: "applicationDate",
      sortOrder: "ASC",
    },
    limit: 2999,
    offset: 0,
  };
  const handleLogout = () => {
    Digit.UserService.logout();
    setIsDropdownOpen(false);
  };
  useEffect(() => {
    const fetchAndSetUserDetails = async () => {
      try {
        const inboxData = await InboxGeneral.Search({ inbox: { ...filters } });
        console.log(inboxData, "inboxData");

        const filteredData = inboxData?.statusMap?.filter(
          (item) => item.applicationstatus === "UPLOAD_DOC" || item.applicationstatus === "REVERT_TO_APPLICANT"
        );
        const inboxCount = filteredData?.reduce((acc, item) => acc + (item?.count || 0), 0);
        console.log({ inboxCount, filteredData }, "inboxxx");

        setCount(inboxCount); // Update state with the count
      } catch (error) {
        console.error("Error fetching notifications:", error);
        setCount(0); // Reset to 0 on error
      }
    };
    fetchAndSetUserDetails();
  }, []);

  return (
    <TopBarContainer>
      <TopBarLeft>
        <TopBarIcon as={collapsed ? ArrowForwardIos : ArrowBackIos} title="Back" onClick={toggleSidebar} style={{ color: "white" }} />
        <TopBarName className="text-white">
          {/* <strong>{info?.name}</strong>  */}
          {(applicationDetail?.landInfo?.owners?.[0]?.name || ownerName) && "Owner:"}
        </TopBarName>
        <TopBarValidity className="text-white">
          {/* <strong>{info?.roles?.filter((e) => e.code !== 'CITIZEN')?.[0]?.name || 'CITIZEN'}</strong> */}
          {applicationDetail?.landInfo?.owners?.[0]?.name || ownerName}
        </TopBarValidity>
        <TopBarName className="text-white">
          {/* <strong>{info?.name}</strong>  */}
          {applicationDetail?.landInfo?.owners?.[0]?.mobileNumber && "Mobile No:"}
        </TopBarName>
        <TopBarValidity className="text-white">
          {/* <strong>{info?.roles?.filter((e) => e.code !== 'CITIZEN')?.[0]?.name || 'CITIZEN'}</strong> */}
          {applicationDetail?.landInfo?.owners?.[0]?.mobileNumber}
        </TopBarValidity>
        {applicationDetail?.land_Id && (
          <React.Fragment>
            <span className="text-white">FASTPAS ID: </span>
            <span className="text-white">{applicationDetail.land_Id}</span>
          </React.Fragment>
        )}
      </TopBarLeft>
      <TopBarRight className="top-right-icon-sec">
        <TopBarIcon
          as={Fullscreen}
          title="Fullscreen"
          onClick={() => {
            if (document.fullscreenElement) {
              document.exitFullscreen();
            } else {
              document.documentElement.requestFullscreen();
            }
          }}
        />
        {/* <TopBarIcon as={FaBell} title="Alerts" /> */}
        {/* <div style={{ position: "relative" }}>
          <TopBarIcon as={FaBell} title="Alerts" />
          <NotificationBadge>{count}</NotificationBadge> 
        </div> */}
        {/* <TopBarIcon as={FaRegMessage} title="Messages" /> */}
        <TopBarIcon
          as={FaQuestionCircle}
          title="Helpdesk"
          onClick={() => window.open("https://mainet.abmindia.com/training/", "_blank", "noopener,noreferrer")}
        />
        <div ref={dropdownRef} style={{ position: "relative" }}>
          <TopBarIcon as={FaUser} title="User" onClick={() => setIsDropdownOpen(!isDropdownOpen)} />
          {isDropdownOpen && (
            <DropdownMenu>
              <DropdownItem onClick={handleDashboard}>{t("FASTPAS.DASHBOARD.MAIN.TEXT")}</DropdownItem>
              <DropdownItem onClick={handleEditProfile}>Edit Profile</DropdownItem>
              <DropdownItem onClick={handleLogout}>Logout</DropdownItem>
            </DropdownMenu>
          )}
        </div>
      </TopBarRight>
    </TopBarContainer>
  );
};

export default TopBar;
